import type { WidgetMessages } from './types.ts';

export const nl: WidgetMessages = {
  panelTitle: 'Feedback versturen',
  panelClose: 'Sluiten',
  fieldTitleLabel: 'Korte samenvatting',
  fieldTitlePlaceholder: 'Korte beschrijving',
  fieldSummaryLabel: 'Details',
  fieldSummaryPlaceholder: 'Stappen om het te reproduceren, wat je verwachtte, wat er gebeurde…',
  fieldNameLabel: 'Je naam',
  fieldEmailLabel: 'Je e-mailadres',
  fieldSaveContactLabel: 'Naam en e-mailadres onthouden',
  fieldSaveContactUnavailable: 'Je browser blokkeert opslag, dus dit kan niet worden bewaard.',
  fieldNotifyOnFixLabel: 'Mail mij wanneer dit is opgelost',
  buttonSend: 'Rapport versturen',
  buttonSending: 'Bezig met versturen…',
  buttonWaitingForUploads: 'Wachten op bijlagen…',
  errorTitleRequired: 'Voeg een korte samenvatting toe.',
  successHeading: 'Bedankt — je rapport is binnen.',
  successCopy: (ref) => `Referentiecode: ${ref}`,
  successPartialNotice: (failed, total) =>
    failed === total
      ? failed === 1
        ? 'Je bijlage kon niet worden verwerkt en is niet meegestuurd met je rapport.'
        : `Alle ${total} bijlagen konden niet worden verwerkt en zijn niet meegestuurd met je rapport.`
      : `${failed} van de ${total} bijlagen konden niet worden verwerkt en zijn niet meegestuurd met je rapport.`,
  successAnotherButton: 'Nog een rapport versturen',
  poweredBy: 'Mogelijk gemaakt door OnCatch',

  recordingConsentTitle: 'Je scherm opnemen',
  recordingConsentLead: (ws) =>
    `Je staat op het punt je scherm te delen met het supportteam van ${ws} om een fout te demonstreren.`,
  recordingConsentBulletAdminsOnly:
    'De opname wordt alleen naar de beheerders van je workspace gestuurd.',
  recordingConsentBulletMicAudio:
    'Microfoon-audio wordt opgenomen als je browser dit ondersteunt; je krijgt hiervoor een toestemmingsverzoek.',
  recordingConsentBulletMaxLength:
    'De maximale duur is 5 minuten — de opname stopt automatisch bij de limiet.',
  recordingConsentBulletRetention: (d) => `${d} dagen bewaard en daarna automatisch verwijderd.`,
  recordingConsentBulletDeletion:
    'Je kunt eerder verwijderen aanvragen via je accountinstellingen.',
  recordingConsentCancelBtn: 'Annuleren',
  recordingConsentAcceptBtn: 'Akkoord, opname starten',
  recordingChoiceTitle: 'Kies een opname',
  recordingChoiceLead:
    'Kies wat u wilt vastleggen. U ziet wat er wordt gedeeld voordat de opname begint.',
  recordingChoiceScreen: 'Schermopname',
  recordingChoiceScreenDetail: 'Neem uw scherm en optioneel microfoonaudio op.',
  recordingChoiceCamera: 'Schermopname met camera',
  recordingChoiceCameraDetail: 'Neem uw scherm op met een camera-overlay.',
  recordingChoiceAudio: 'Audio-opname',
  recordingChoiceAudioDetail: 'Neem alleen uw microfoonaudio op.',
  recordingChoiceUnavailable: 'Niet beschikbaar in deze browser',
  recordingAudioConsentTitle: 'Audio opnemen',
  recordingAudioConsentLead: (ws) =>
    `Uw microfoonaudio wordt gedeeld met het ondersteuningsteam van ${ws} om dit probleem toe te lichten.`,
  recordingAudioConsentTip:
    'Uw browser vraagt nu om microfoontoegang. Kies de microfoon die u wilt gebruiken en geef toegang.',

  recordingTimerIdle: 'Opname 0:00',
  recordingTimer: (m, s) => `Opname ${m}:${String(s).padStart(2, '0')}`,
  recordingStopBtn: 'Stoppen',
  recordingStartedAnnouncement: 'Opname gestart',
  recordingProgressAnnouncement: (sec) => `Opname ${sec} seconden`,

  captureRegionHelp: 'Klik en sleep om een gebied te selecteren · Druk op Esc om te annuleren',
  captureLabelCapturing: 'Bezig met vastleggen…',
  captureLabelPreparing: 'Bezig met voorbereiden…',
  captureRegionCapturing: 'Gebied vastleggen…',

  safariUnsupportedTitle: 'Schermopname wordt niet ondersteund in deze browser',
  safariUnsupportedBody:
    'Schermopname vereist Chrome, Edge of Firefox op desktop. Je kunt nog steeds screenshots toevoegen en je rapport versturen.',

  attachmentsLabel: 'Bijlagen',
  captureWholePageBtn: 'Hele pagina',
  captureSelectRegionBtn: 'Gebied selecteren',
  captureSelectElementBtn: 'Element selecteren',
  captureRecordBtn: 'Opnemen',
  cameraDeniedFallback: 'Toegang tot camera geweigerd — alleen scherm wordt opgenomen.',
  recordingConsentBulletCamera:
    'Je camerabeeld wordt in de hoek van de opname getoond. Weiger de camera-vraag om alleen het scherm op te nemen.',
  recordingConsentIncludeCameraLabel: 'Camera toevoegen',
  recordingUnsupportedInline:
    'Schermopname wordt niet ondersteund in deze browser. Schermafbeeldingen werken nog steeds.',

  // ── Upload dropzone (#605) ───────────────────────────────────────────
  uploadDropzoneBtn: 'Bestand uploaden',
  uploadDropzoneHint: () => 'PNG, JPEG, WebP · PDF, Word (.docx)',
  uploadDropzoneCapReached: 'Bijlagelimiet bereikt — verwijder er een om te uploaden.',
  uploadErrorUnsupportedType:
    'Alleen PNG-, JPEG-, WebP-, PDF- of DOCX-bestanden kunnen worden geüpload.',
  uploadErrorFileTooLarge: 'Bestand te groot (max. 50 MB).',
  uploadErrorGeneric: 'Uploaden mislukt. Probeer het opnieuw.',
  uploadErrorTooMany: (skipped) =>
    skipped === 1
      ? '1 bestand overgeslagen — bijlagelimiet bereikt.'
      : `${skipped} bestanden overgeslagen — bijlagelimiet bereikt.`,

  storageFullNotice: 'Bijlagen niet beschikbaar',
  storageFullDetailedNotice: 'Bijlagen niet beschikbaar — workspace-opslag vol',

  challengeIntro: 'Snelle controle om te bevestigen dat je een mens bent.',
  challengeFailed: 'Verificatie mislukt. Probeer het opnieuw.',

  annotateTitle: 'Schermafbeelding annoteren',
  toolArrow: 'Pijl',
  toolBox: 'Kader',
  toolPen: 'Tekenen',
  toolText: 'Tekst',
  colorRed: 'Rood',
  colorYellow: 'Geel',
  colorGreen: 'Groen',
  colorBlack: 'Zwart',
  buttonUndo: 'Ongedaan',
  buttonClear: 'Wissen',
  buttonSkip: 'Overslaan',
  buttonSave: 'Opslaan',
  textInputPlaceholder: 'Typ label, druk op Enter',
  saveError: 'Opslaan mislukt. Originele schermafbeelding wordt gebruikt.',
  activeIndicator: 'actief',
};
